import React from 'react';

import BullSeparator from 'components/BullSeparator';
import { I18n, translate } from 'components/translate';
import { withFeatureToggle } from 'hoc/withFeatureToggle';
import get from 'lodash/get';
import { CommunityService } from 'modules/community';
import { FeatureToggles } from 'modules/featureToggle';
import { USER_ROLES_LABEL } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import { ROLES } from '../../user/constants';

const DEFAULT_ROLES = [USER_ROLES_LABEL.MODERATOR];

const WEIGHT_BY_ROLE = {
  [ROLES.OWNER]: 3,
  [ROLES.ADMIN]: 2,
  [ROLES.MODERATOR]: 1
};

const LABEL_BY_ROLE_WEIGHT = {
  1: 'users_import.roles.moderator',
  2: 'users_import.roles.administrator',
  3: 'general.producer'
};

/**
 * Returns the role from the given `roles` array that has the
 * highest weight (as per `WEIGHT_BY_ROLE` map).
 * If role is empty or falsy, returns the default role, *moderator*.
 * @param {Array<string>} roles - Roles assigned to a user
 * @returns {string} The predominant role.
 */
export const getPredominantRole = (roles) => {
  const roleWeights = (roles || DEFAULT_ROLES).map(
    (role) => WEIGHT_BY_ROLE[role] || 1
  );
  const maxRoleWeight = roleWeights.reduce((a, b) => {
    return Math.max(a, b);
  }, 0);

  return LABEL_BY_ROLE_WEIGHT[maxRoleWeight] || USER_ROLES_LABEL.MODERATOR;
};

const CommentPersonaHeader = ({ item, t }) => {
  const commentedAsPersona = get(item, 'commentedAsPersona', false);

  if (!commentedAsPersona) {
    return null;
  }

  const persona = CommunityService.persona;
  const personaName = get(persona, 'name', '');

  const roles = get(item, 'user.roles', DEFAULT_ROLES);

  return (
    <div
      className="_mt-1 _tw-text-sm _line-height-lg lg:_text-1 _text-gray-400"
      data-test="comment-persona-header"
    >
      <span>
        <I18n label={getPredominantRole(roles)} />
      </span>
      <BullSeparator className="_mx-2" />
      <span>{`${t(
        'community.configuration.persona.replying_as'
      )} "${personaName}"`}</span>
    </div>
  );
};

CommentPersonaHeader.propTypes = {
  item: PropTypes.shape({
    commentedAsPersona: PropTypes.bool
  }),
  t: PropTypes.func
};

export { CommentPersonaHeader };

export default withFeatureToggle(
  translate()(CommentPersonaHeader),
  FeatureToggles.PersonaConfig
);
